import React, { useMemo } from 'react'
import { RouteProps } from 'react-router-dom'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import ForgotPasswordTemplate, {
  ForgotPasswordTemplateProps,
} from '../../templates/Password/forgot'
import { useFooter } from '../../relay/Footer/useFooter'
import { useHeader } from '../../relay/Header/useHeader'
import { actions, selectors } from '../../redux'

const ForgotPasswordPage: React.FC<RouteProps> = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const header = useHeader()
  const footer = useFooter()

  const forgot = useSelector(selectors.auth.forgot)

  const templateProps: ForgotPasswordTemplateProps = useMemo(
    () => ({
      layout: {
        header,
        footer,
      },
      forgotPasswordForm: {
        background: `${import.meta.env.BASE_URL}images/onboarding/pickCCI.jpg`,
        header: {
          title: t('password.forgot.header.title'),
        },
        content: {
          title: t('password.forgot.content.title'),
          formikForm: {
            initialValues: {
              email: '',
            },
            validationSchema: Yup.object().shape({
              email: Yup.string().required().email(),
            }),
            onSubmit: (values) => {
              dispatch(
                actions.auth.forgotRequest({
                  email: values.email,
                })
              )
            },
            validateOnChange: false,
          },
          fields: {
            email: {
              name: 'email',
              label: t('password.forgot.email.label'),
              placeholder: t('password.forgot.email.placeholder'),
              required: true,
            },
          },
          errors: forgot.errors,
          submitButton: {
            text: t('password.forgot.submit.label'),
            isPending: forgot.pending,
            isSuccess: forgot.success,
            pendingText: t('password.forgot.submit.pending'),
            successText: t('password.forgot.submit.success'),
          },
        },
      },
    }),
    [dispatch, footer, forgot.errors, forgot.pending, forgot.success, header, t]
  )

  return <ForgotPasswordTemplate {...templateProps} />
}

export default ForgotPasswordPage
